import type { Membership } from './types';

/** A plain object: not `null`, not an array. */
export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Looks like a `/me` membership — a string `status` and a `plan` object.
 * Anything else in an answer is not trusted as a membership.
 */
export const isMembershipShape = (value: unknown): value is Membership =>
  isRecord(value) && typeof value.status === 'string' && isRecord(value.plan);
